import {Component, HostBinding, Input, OnDestroy, OnInit} from '@angular/core';
import {DiagnosticOrderActionsService} from "@ispm/test/services/diagnostic-order-actions.service";
import {TestRunningMode} from "@ispm/test/interfaces/test-running-mode.enum";
import { TestService } from '../../services/test.service';
import { WorkflowService } from '@ispm/workflow/services/workflow.service';
import { ElementRef } from '@angular/core';
import { TreatmentSelectionService } from '@ispm/therapies/services/treatment-selection.service';
import { ActivatedRoute, Router } from "@angular/router";
import { RouterManagerService } from '@ispm/core/services/router-manager.service';
import { AuthenticationService } from "@ispm/user/services/authentication.service";
import { PermissionSchemaConstants } from "@ispm/shared/constants/permission-schema.constants";

@Component({
  selector: 'gen-profile-v2',
  templateUrl: './profileV2.component.html',
  styleUrls: ['./profileV2.component.scss'],
})
export class ProfileV2Component implements OnInit, OnDestroy {

  @HostBinding('style.width.%') width: number;
  public loaded = false;
  stateParams: any;
  patientId: string;
  currentUser: any;
  showDuplicatePatient: boolean;
  backUrl: string;
  backUrlParams: any;
  showProfileHeader: boolean;
  previewMode: boolean = false;
  showTestActions: boolean = true;

  availableDimensions: any;
  overflownDimensions: any;
  testViewBarDimensions: any;
  ptNavigationContextBarDimensions: any;
  navigationPanelDimensions: any;
  treatmentSelectionNotesDimensions: any;
  listInfoSectiondDimensions: any;

  isCustomConfig: boolean = false;
  @Input() patientProfile: any;
  @Input() patient: any;

  constructor(public route: ActivatedRoute,
              private diagOrderActionsService: DiagnosticOrderActionsService,
              private workflowService: WorkflowService,
              private testService: TestService,
              private treatmentSelectionService: TreatmentSelectionService,
              private elementRef: ElementRef,
              private routerManagerService: RouterManagerService,
              private authService: AuthenticationService,
              private router: Router) {
  }

  ngOnInit() {
    //this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.loaded = this.route.snapshot.data['patientParams'] ? true: false;
    this.width = 100;
    this.currentUser = JSON.parse(localStorage.user);
    this.stateParams = this.routerManagerService.parameters;
    this.patientId = this.routerManagerService.parameters.patientId;
    // if (this.route.snapshot.paramMap['#'] && this.route.snapshot.paramMap['#'] == 'previewMode'){
    //   this.previewMode = true;
    // }

    // get if 'duplicatePatientWarning' is enabled by the test's configuration
    let showDuplicatePatientByConfig = false;
    if (this.testService.testConfiguration && this.testService.testConfiguration.duplicatePatientWarning) {
      showDuplicatePatientByConfig = this.testService.testConfiguration.duplicatePatientWarning.showDuplicatePatient;
      this.backUrl = this.testService.testConfiguration.duplicatePatientWarning.backUrl;
      this.backUrlParams = this.testService.testConfiguration.duplicatePatientWarning.backUrlParams;
    }

    // get if 'duplicatePatientWarning' is enabled by the diagnostic-order's configuration. This is required in order to
    //  make sure that the 'duplicatePatientWarning' is displayed only once and if this flag was already being set off
    //  the diagnostic-order's configuration, there is no need to to show this warning anymore
    this.diagOrderActionsService.getState()
      .take(1)
      .filter(res => !!res && !!res.order)
      .subscribe(res => {
        this.showDuplicatePatient = showDuplicatePatientByConfig && res.order['showDuplicatePatient'] != false;
        const testInSpecialMode = !!res.order.runningMode && res.order.runningMode != TestRunningMode.REGULAR_MODE;
        this.showTestActions = testInSpecialMode ?  this.testService.showTestActions(res.order.runningMode): true;
    });

    this.showTestActions = this.authService.doesUserHasPermission(PermissionSchemaConstants.schemaWorkflowBackAction) ? false : this.showTestActions;
    this.showProfileHeader = this.testService.testConfiguration && this.testService.testConfiguration.ShowProfileHeader;

    const value=this.workflowService.getPatientAnalyses(this.stateParams, false);
    value.then(res => {
      // this.testService.patientTests = res.body.allTests;
    }
    )
    .catch((err) => console.error('getPatientAnalyses Failer: ', err))
    .finally(() =>{this.loaded = true; });

    this.isCustomConfig = this.route.firstChild?.snapshot.data['isCustomConfig'];

  }

  ngAfterViewChecked() {
    const elementsArray = Array.from(document.querySelectorAll( '[class*="PATHWAYS_SUBJECT_WRAPPER_NO_PRIORITY_BINDED"]' ));
    if (elementsArray.length > 0) {
      elementsArray.forEach(el => {
          if (el.className.includes('-note')) {

            const treatmentSelectionNotesDim = el.getBoundingClientRect();
            const availableDim = this.elementRef.nativeElement.querySelector('gen-test-view')?.getBoundingClientRect();
            const testViewBarDim = this.elementRef.nativeElement.querySelector('.test-view-bar')?.getBoundingClientRect();
            const ptNavigationContextBarDim = this.elementRef.nativeElement.querySelector('.pt-primary-navigation')?.getBoundingClientRect();
            const navigationPanelDim = this.elementRef.nativeElement.querySelector('gen-dynamic-form.navigation_panel')?.getBoundingClientRect(); // 2X
            const listInfoSectiondDim = this.elementRef.nativeElement.querySelector('.info-section-headers')?.getBoundingClientRect();

            if (JSON.stringify(this.availableDimensions) !== JSON.stringify(availableDim) ||
              JSON.stringify(this.testViewBarDimensions) !== JSON.stringify(testViewBarDim) ||
              JSON.stringify(this.ptNavigationContextBarDimensions) !== JSON.stringify(ptNavigationContextBarDim) ||
              JSON.stringify(this.navigationPanelDimensions) !== JSON.stringify(navigationPanelDim) ||
              JSON.stringify(this.treatmentSelectionNotesDimensions) !== JSON.stringify(treatmentSelectionNotesDim) ||
              JSON.stringify(this.listInfoSectiondDimensions) !== JSON.stringify(listInfoSectiondDim)

            ) {

              this.availableDimensions = availableDim;
              this.testViewBarDimensions = testViewBarDim;
              this.ptNavigationContextBarDimensions = ptNavigationContextBarDim;
              this.navigationPanelDimensions = navigationPanelDim;
              this.treatmentSelectionNotesDimensions = treatmentSelectionNotesDim;
              this.listInfoSectiondDimensions = listInfoSectiondDim;

              const calculatedHeight = (this.availableDimensions?.height -
                this.testViewBarDimensions?.height -
                this.ptNavigationContextBarDimensions?.height -
                (this.navigationPanelDimensions?.height * 2) -
                this.treatmentSelectionNotesDimensions?.height -
                this.listInfoSectiondDimensions?.height);

              const calculatedDetailsHeight = (this.availableDimensions?.height -
                this.testViewBarDimensions?.height -
                this.ptNavigationContextBarDimensions?.height -
                (this.navigationPanelDimensions?.height * 2));

              this.treatmentSelectionService.therapiesAndTrailCalculatedHeight$.next(calculatedHeight + 'px');
              this.treatmentSelectionService.therapiesAndTrailCalculatedDetailsHeight$.next(calculatedDetailsHeight + 'px');
            }

          }
        }
      );
    }

  }

  ngOnDestroy() {
  }
}

